import { call, put, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';

export function* reactivate({ payload: { companyId } }) {
    try {
        const response = yield call(
            dataProvider.updateOnly,
            `Companies/${companyId}/reactivate`,
            {}
        );

        yield put({
            type: currentCompany.companyAdminInfo.reactivate.end,
            payload: response.data,
        });

        yield put({
            type: notification.add,
            payload: { success: 'Contractor has been reactivated successfully' },
        });
    } catch (e) {
        yield put({ type: currentCompany.companyAdminInfo.reactivate.error });
        yield put({ type: notification.add, payload: { error: e.message } });
    }
}

export default function* reactivateContractor() {
    yield takeLatest(currentCompany.companyAdminInfo.reactivate.start, reactivate);
}
